const benefits = [
  {
    title: "Industry Experts",
    desc: "Our skilled developers bring real-world experience to deliver top-quality tech outcomes.",
    delay: "0",
  },
  {
    title: "Professional Service",
    desc: "We use agile methods and collaborate closely to build exactly what your business.",
    delay: "100",
  },
  {
    title: "Smart Consulting",
    desc: "We offer fresh insights to help you lead with innovation, adaptability, and growth.",
    delay: "200",
  },
  {
    title: "Efficient Delivery",
    desc: "Ongoing improvement and fast execution help reduce time, cost, and resource use.",
    delay: "300",
  },
  {
    title: "Trusted by Clients",
    desc: "Clients value our integrity, consistent results, and long-term commitment.",
    delay: "400",
  },
  {
    title: "Global Partnerships",
    desc: "We team up with leading tech partners to scale and tailor your solution as you grow.",
    delay: "500",
  },
];

export default function AboutBenefit() {
  return (
    <section id="benefit">
      <div className="benefit-section-wrapper w-full py-16 md:pb-[153px]">
        <div className="mx-auto theme-container px-4">
          <div className="w-full">
            <div className="flex flex-col items-center">
              <h1 className="border text-chip border-purple/30 py-0.5 px-5 rounded-[30px] w-fit mb-5">
                Why Choose Impera?
              </h1>
              <h2 className="text-34 sm:text-48 font-semibold text-white mb-10 sm:mb-[60px] text-center max-w-[653px]">
                We Combine Smart Tech With Real Business Impact
              </h2>
            </div>
          </div>
          <div className="w-full grid grid-cols-6 lg:grid-cols-12 gap-5 sm:gap-[70px]">
            <div className="flex items-center justify-center col-span-6 relative">
              <img
                src="./assets/images/benefit-img.webp"
                alt="benefit"
                className="max-w-full"
              />
            </div>
            <div className="flex items-center col-span-6">
              <div className="grid grid-cols-3 sm:grid-cols-6 gap-[30px]">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    data-aos="fade-left"
                    data-aos-delay={benefit.delay}
                    data-aos-duration="1000"
                    className="max-w-full col-span-3 relative h-full "
                  >
                    <div className="rounded-[10px] m-[1px] price_card_bg px-[26px] py-5 border border-transparent relative z-10 h-full flex flex-col">
                      {/* Content Block */}
                      <div>
                        <h1 className="font-semibold text-18 font-inter text-white">
                          {benefit.title}
                        </h1>
                        <p className="text-paragraph mt-2">{benefit.desc}</p>
                      </div>

                      {/* Spacer pushes content to top, leaves remaining space below */}
                      <div className="flex-grow"></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
